<template>
  <teksten />
</template>

<script>
import Teksten from '../components/Teksten.vue'

export default {
  name: 'TekstenView',
  components: {
    Teksten
  }
}
</script>
